<template>
	<r-standard-modal-form
		class="import-modal-outter"
		@closeModal="$emit('closeModal')">
		<span slot="title">Importing From {{ importTypeLabel }}</span>
		<div slot="body" class="import-data-modal-body">
			<div class="message-container p-typography-regular-14">
				<div class="education-paragraph">
					Visor supports pasted data from most spreadsheets.
				</div>
				<div class="education-paragraph">
					Before pasting into Visor, confirm your columns in Visor exactly match the number, types, and order of columns in your source spreadsheet.
				</div>
			</div>
			<p-button
				type="primary"
				@onClick="closeForm">Ok</p-button>
		</div>
	</r-standard-modal-form>
</template>
<script>
export default {
	$pubsub: {},
	props: {
		sheetView: {
			required: true,
			type: Object,
		},
		importType: {
			required: true,
			type: String,
		},
	},
	computed: {
		dataStore() {
			return this.sheetView.sheetViewGroup.dataStore;
		},
		importTypeLabel() {
			if (this.importType === 'googleSheet') {
				return "Google Sheets";
			} else if(this.importType === 'excel') {
				return "Excel";
			} else {
				return "";
			}
		}
	},
	methods: {
		closeForm() {
			this.$emit('closeModal');
		}
	}
}
</script>
<style scoped lang="scss">
div.import-modal-outter {
	width: 350px;
	button {
		width: 100%;
	}
	div.import-data-modal-body {
		width: 100%;
		.message-container {
			.education-paragraph {
				margin-bottom: 24px;
				&.grow {
					display: flex;
					flex-grow: 1;
				}
			}
		}
	}
}
</style>
